import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { FormRulesTabPanel } from "@/features/form-editor/components/form-rules-tab-panel";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/assetTypes/$assetTypeId/full/form/rules",
)({
	component: FormRulesTabPanel,
	params: {
		parse: (raw) => {
			const p = raw as { orgId: string; assetTypeId: string };
			return {
				orgId: z.string().parse(p.orgId),
				assetTypeId: z.string().parse(p.assetTypeId),
			};
		},
	},
});
